import React, { useEffect, useState } from 'react';
import '../NewsPage/OneNewsPage.css';
import axios from 'axios';
import { useParams } from 'react-router';
import { ClipLoader } from 'react-spinners';

function OneNewsPage() {
    const API = process.env.REACT_APP_API_BASE_URL || '';
    const [news, setNews] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        axios.get(`${API}/news/${id}`).then((result) => {
            setNews({ ...result.data, date: result.data.date.substr(0, 10) });
        });
    }, []);

    return (
        <div>
            <div className='container_all'>
                <div className='news_page'>
                    {news == null ? (
                        <div style={{ display: 'grid', placeItems: 'center', height: '100%', padding: '30px 0' }}>
                            <ClipLoader size={70} color='#396fc5' />
                        </div>
                    ) : (
                        <>
                            <div className='newspage_title'>
                                <h1>{news?.title}</h1>
                            </div>
                            <div className='newspage_info'>
                                <div className='short'>
                                    <div className='im'>
                                        <img src={news?.image} alt={news?.title} />
                                    </div>
                                    <div className='txt'>
                                        <div className='short_txt'>
                                            <p>{news?.short_text}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='all_text' dangerouslySetInnerHTML={{ __html: news?.text }}></div>
                                <div className='short_date'>
                                    <p>Дата: {news?.date}</p>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default OneNewsPage;
